import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";

@Component({
  selector: "app-userfb-detail",
  templateUrl: "./userfb-detail.component.html",
  styleUrls: ["./userfb-detail.component.scss"],
})
export class UserfbDetailsComponent implements OnInit {
  selectedIndex: number;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit(): void {
    const fragment = this.route.snapshot.fragment;
    if (fragment === "product") {
     
      this.selectedIndex = 1;
    }
  }

  handleProductTabClick(e: any) {
    const baseURL =
        this.route.snapshot.url[0].path +
        "/" +
        this.route.snapshot.url[1].path +
        "/" +
        this.route.snapshot.url[2].path;

    if (e.index === 1 && this.route.snapshot.fragment !== "product") {
      this.route.snapshot.fragment = "product";
      this.location.go(baseURL + "#product");
    } else {
      this.route.snapshot.fragment = "";
      this.location.go(baseURL);
    }
  }
}
